export const routes = {
  route1: {
    id: "route1",
    title: "red",
    bgColor: "red",
    zIndex: 1,
  },
  route2: {
    id: "route2",
    title: "green",
    bgColor: "green",
    zIndex: 2,
  },
  route3: {
    id: "route3",
    title: "blue",
    bgColor: "blue",
    zIndex: 3,
  }
};



// WEBPACK FOOTER //
// ./src/routes/index.js